import { Box, Flex, Grid, GridItem, Image, Text, useBreakpointValue } from "@chakra-ui/react";
import { useMemo } from "react";

import ButtonCompartir from "@/components/fichas/buttonCompartir";
import GalleryImages from "@/components/general/desarrollo/GalleryImages";
import GallerySlide from "@/components/general/desarrollo/GallerySlide";

const CentralBanner = ({
    dataDevelopment,
    city,
    session,
    saveDevFavorites,
    userFavorites,
    setIsRouteViewer,
}) => {
    //Validar si el desarrollo es favorito
    const isFavorite = useMemo(() => {
        return userFavorites?.some((fav) => fav.development_id === dataDevelopment.development_id);
    }, [userFavorites]);

    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });

    return (
        <>
            <Grid
                templateColumns={{ base: "repeat(2, 1fr)", md: "repeat(3, 1fr)" }}
                gap={4}
                pt={{ base: "10vh", md: 14 }}
                alignItems="center"
            >
                <GridItem display="flex" alignItems="center" colSpan={1}>
                    {dataDevelopment?.extra_props?.logo && (
                        <Image
                            src={dataDevelopment?.extra_props?.logo}
                            alt="develop"
                            maxH="7vh"
                            maxW={{ base: "25vw", md: "10vw" }}
                        />
                    )}
                </GridItem>

                <GridItem display="flex" alignItems="initial" colSpan={1}>
                    <Text
                        px={{ base: "0", md: "1vw", lg: "5vw" }}
                        ml={{ base: "auto", md: "auto" }}
                        mr={{ base: "none", md: "auto" }}
                        fontWeight={700}
                        fontSize={{ base: "lg", md: "2xl" }}
                        textAlign="center"
                    >
                        {dataDevelopment?.name
                            ?.toLocaleLowerCase("es")
                            .replace(/(^|\s)\p{L}/gu, (match) => match.toLocaleUpperCase("es")) ||
                            ""}
                    </Text>
                </GridItem>

                <GridItem
                    display="flex"
                    justifyContent={{ base: "center", md: "flex-end" }}
                    alignItems="center"
                    colSpan={{ base: 2, md: 1 }}
                    flexShrink={0}
                >
                    <Flex gap={5}>
                        <Box
                            align="center"
                            cursor="pointer"
                            _hover={{ bg: "gray.100" }}
                            _active={{ bg: "gray.200" }}
                            borderRadius="md"
                        >
                            <ButtonCompartir
                                icon="https://media.grupoguia.mx/assets/home-page/fichas/compartir+2.svg"
                                url={`https://grupoguia.mx/desarrollo/${city && city !== dataDevelopment?.name.toLowerCase().replaceAll(" ", "").replaceAll("ú", "u").replaceAll("ó", "o").replaceAll("í", "i").replaceAll("é", "e").replaceAll("á", "a") ? `${city}/` : ""}${dataDevelopment?.name.toLowerCase().replaceAll(" ", "").replaceAll("ú", "u").replaceAll("ó", "o").replaceAll("í", "i").replaceAll("é", "e").replaceAll("á", "a")}`}
                                fontsize="sm"
                            >
                                Compartir
                            </ButtonCompartir>
                        </Box>
                        {session && (
                            <Flex
                                gap={3}
                                align="center"
                                cursor="pointer"
                                _hover={{ bg: "gray.100" }}
                                _active={{ bg: "gray.200" }}
                                p={2}
                                borderRadius="md"
                                onClick={(e) => {
                                    e.preventDefault();
                                    saveDevFavorites(null, dataDevelopment?.development_id);
                                }}
                            >
                                <Image
                                    src={
                                        isFavorite
                                            ? "https://media.grupoguia.mx/assets/apps-icons/favorite_active.svg"
                                            : "https://media.grupoguia.mx/assets/apps-icons/favorite.svg"
                                    }
                                    alt="favorite"
                                    maxH="3vh"
                                />

                                <Text fontWeight="400" fontSize="sm" color="black" textAlign="end">
                                    Favorito
                                </Text>
                            </Flex>
                        )}
                    </Flex>
                </GridItem>
            </Grid>
            {isGreaterThanMd ? (
                <GalleryImages
                    images={dataDevelopment?.images}
                    koppi={dataDevelopment?.external_props?.koppi}
                    setIsRouteViewer={setIsRouteViewer}
                />
            ) : (
                <GallerySlide
                    images={dataDevelopment?.images}
                    koppi={dataDevelopment?.external_props?.koppi}
                    setIsRouteViewer={setIsRouteViewer}
                />
            )}
        </>
    );
};

export default CentralBanner;
